var map = {
	"./0deg.svg": "a587",
	"./135deg.svg": "2015",
	"./180deg.svg": "d70f",
	"./225deg.svg": "c0a9",
	"./270deg.svg": "861d",
	"./315deg.svg": "8977",
	"./3MLogo.svg": "4982",
	"./3dForm1.svg": "bde1",
	"./3dForm2.svg": "0259",
	"./3dForm3.svg": "f263",
	"./3dForm4.svg": "352e",
	"./3dForm5.svg": "c770",
	"./3dForm6.svg": "9e3d",
	"./3dForm7.svg": "b564",
	"./45deg.svg": "fe20",
	"./90deg.svg": "4e35",
	"./aoneLogo.svg": "c137",
	"./blue.svg": "f0e6",
	"./brown.svg": "da7c",
	"./checkBoxOffBlack.svg": "434f",
	"./cloudBalloonTriangle.svg": "64a3",
	"./colorPickerCancel.svg": "7b89",
	"./colorPickerTriangle.svg": "42a6",
	"./dropbox.svg": "67dd",
	"./end1.svg": "f543",
	"./end2.svg": "ebce",
	"./end3.svg": "3306",
	"./end4.svg": "2169",
	"./end5.svg": "c290",
	"./error_img.svg": "0568",
	"./facebook_sample_icon.svg": "b889",
	"./facebook_sample_image.svg": "2c9e",
	"./facebook_sample_nice_icon.svg": "7980",
	"./facebook_sign_in.svg": "dd67",
	"./googleDrive.svg": "485c",
	"./gray.svg": "1353",
	"./green.svg": "121f",
	"./labelyasanCloud.svg": "2576",
	"./lightGreen.svg": "d8e0",
	"./line0.svg": "13ed",
	"./line1.svg": "ae4a",
	"./line2.svg": "9a1f",
	"./line3.svg": "86d7",
	"./line4.svg": "9d1a",
	"./lockIcon.svg": "8de5",
	"./logo.png": "cf05",
	"./middle.svg": "dd01",
	"./noImage.png": "b3fe",
	"./objArrowDown.svg": "aea0",
	"./objArrowRight.svg": "4cd8",
	"./objBarcode.svg": "645f",
	"./objCalendar.svg": "e9d6",
	"./objCurve.svg": "156d",
	"./objCustomText.svg": "9973",
	"./objFolder.svg": "21b3",
	"./objImage.svg": "e6aa",
	"./objLine.svg": "7ae9",
	"./objPolygon.svg": "59be",
	"./objQrcode.svg": "33ed",
	"./objSerialNumber.svg": "1038",
	"./objTable.svg": "8515",
	"./objText.svg": "6fad",
	"./oneDrive.svg": "578e",
	"./orange.svg": "4294",
	"./pink.svg": "4ef0",
	"./purple.svg": "1b17",
	"./radioButtonOffBlack.svg": "dc70",
	"./rainbow.svg": "0bee",
	"./red.svg": "d222",
	"./redoButtonOff.svg": "cd5e",
	"./reset.svg": "c870",
	"./rotationArrow.png": "b95a",
	"./rotationArrow.svg": "f875",
	"./smallLogo.svg": "27ec",
	"./start1.svg": "cb4d",
	"./start2.svg": "b5b8",
	"./start3.svg": "d15f",
	"./start4.svg": "e7c6",
	"./start5.svg": "c556",
	"./template_fb.png": "8f1d",
	"./template_tw.png": "852e",
	"./topTitle.svg": "2ecd",
	"./triangleRightBlack.svg": "a3dd",
	"./twitter_sample_icon.svg": "6e82",
	"./twitter_sample_image.svg": "3bff",
	"./twitter_sample_nice_icon.svg": "dbba",
	"./twitter_sign_in.svg": "5e45",
	"./undoButtonOff.svg": "049a",
	"./white.svg": "9f3cd",
	"./yellow.svg": "7fe6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";